import React, {useState} from 'react';
import BaseButton from "./BaseButton";
import Loader from "./Loader";
import backendApi from "../services/backendApi";

function RideInSearch({ setRideInSearch }) {

    const [loading, setLoading] = useState(false);

    const cancelOrder = async () => {
        setLoading(true);

        try {
            const response = await backendApi.post('/api/cancel-pending-order');
        } catch (error) {
            console.error("Order cancellation failed:", error);
        } finally {
            setRideInSearch(false);
            setLoading(false);
        }
    };

    if (loading) return <Loader />;

    return (
        <div className="orderInSearch">
            <div className="radar" />
            <div className="status-text">Ieškomas automobilis...</div>
            <BaseButton
                text={`Atšaukti`}
                handleOnClick={cancelOrder}
                className={'baseButton--primary'}
            />
        </div>
    );
}

export default RideInSearch;